import api from './api'

export const vendorsService = {
  getAll: async (params = {}) => {
    const res = await api.get('/vendors', { params })
    return res.data
  },

  getById: async (id) => {
    const res = await api.get(`/vendors/${id}`)
    return res.data.data
  },

  // Admin-creates a vendor by first registering a user, then onboarding them
  // Uses /vendors/onboard on behalf of a user — not a direct admin endpoint per docs,
  // so we create the user account and trigger onboard in sequence
  create: async (data) => {
    const res = await api.post('/vendors/onboard', data)
    return res.data.data
  },

  approve: async (id) => {
    const res = await api.patch(`/vendors/${id}/approve`)
    return res.data.data
  },

  reject: async (id, rejectionReason) => {
    const res = await api.patch(`/vendors/${id}/reject`, { rejectionReason })
    return res.data.data
  },

  suspend: async (id) => {
    const res = await api.patch(`/vendors/${id}/suspend`)
    return res.data.data
  },

  updateCommission: async (id, commissionRate) => {
    const res = await api.patch(`/vendors/${id}/commission`, { commissionRate })
    return res.data.data
  },

  getStats: async () => {
    const res = await api.get('/vendors/me/stats')
    return res.data.data
  },

  // Admin: get stats for any vendor by ID
  getStatsById: async (id) => {
    const res = await api.get(`/vendors/${id}/stats`)
    return res.data.data
  },
}
